import React from 'react';

/* Magnifier zoom icons for the A−/A+ page-zoom controls. Inline SVG,
   stroke follows currentColor so themes and accents style them free. */

const base = {
  width: 17,
  height: 17,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2.4,
  strokeLinecap: 'round',
  'aria-hidden': true,
  focusable: false,
};

export const ZoomOutIcon = () => (
  <svg {...base}>
    <circle cx="10.5" cy="10.5" r="6.5" />
    <line x1="7.5" y1="10.5" x2="13.5" y2="10.5" />
    <line x1="20.5" y1="20.5" x2="15.5" y2="15.5" />
  </svg>
);

export const ZoomInIcon = () => (
  <svg {...base}>
    <circle cx="10.5" cy="10.5" r="6.5" />
    <line x1="7.5" y1="10.5" x2="13.5" y2="10.5" />
    <line x1="10.5" y1="7.5" x2="10.5" y2="13.5" />
    <line x1="20.5" y1="20.5" x2="15.5" y2="15.5" />
  </svg>
);
